import { render } from "./CustomSelectOne.vue?vue&type=template&id=4b4f54ec&scoped=true"
import script from "./CustomSelectOne.vue?vue&type=script&lang=js"
export * from "./CustomSelectOne.vue?vue&type=script&lang=js"

import "./CustomSelectOne.vue?vue&type=style&index=0&id=4b4f54ec&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4f54ec"]])

export default __exports__